import { Icon } from "@mdi/react";
import { ReactElement } from "react";

import { mdiChartLine, mdiFilter, mdiFocusAuto, mdiMapMarker } from "@mdi/js";
import { EvaChart } from "constants/charts.enums";
import { uid } from "utils";

import { mBinSize } from "models/binSize";
import { EntityKind } from "models/entityKind";

import { AutomationGroup } from "./automation";
import {
  ChartScreenshotPayload,
  GoToMapPayload,
  LoadSavedFilterPayload,
  MapScreenshotPayload,
  SetChartPayload,
  SetFocusPayload
} from "./payloads";
import { CommandId, Topics } from "./topics";

export const commandsTemplate: Array<{
  id: CommandId;
  icon: ReactElement;
  template: AutomationGroup;
}> = [
  {
    id: "load-filter",
    icon: <Icon path={mdiFilter} size={4} />,
    template: {
      id: "load-filter",
      commands: [
        {
          delay: 1000,
          id: uid(),
          payload: {
            projectName: "",
            filterName: ""
          } as LoadSavedFilterPayload,
          topic: Topics.LoadProject
        },
        {
          delay: 1000,
          id: uid(),
          payload: {
            projectName: "",
            filterName: ""
          } as LoadSavedFilterPayload,
          topic: Topics.LoadSavedFilter
        }
      ],
      name: "Load Saved Filter"
    }
  },
  {
    id: "goto",
    icon: <Icon path={mdiMapMarker} size={4} />,
    template: {
      id: "goto-map",
      commands: [
        {
          delay: 1000,
          id: uid(),
          payload: {
            location: [-100, 100],
            zoom: 10
          } as GoToMapPayload,
          topic: Topics.GoTo
        }
      ],
      name: "Go To Location"
    }
  },
  {
    id: "set-focus",
    icon: <Icon path={mdiFocusAuto} size={4} />,
    template: {
      id: uid(),
      commands: [
        {
          delay: 500,
          id: uid(),
          payload: {
            bin: (() => {
              const binSize = new mBinSize(0, null, 1, null);
              binSize.BinType = "BinSize";
              return binSize;
            })(),
            canBin: false,
            categoryId: 0,
            dataType: "Text",
            display: "",
            entityKind: EntityKind.Well,
            groupByField: "",
            property: "",
            title: "",
            tooltip: "",
            pdenSource: ""
          } as SetFocusPayload,
          topic: Topics.SetFocus
        }
      ],
      name: "Set Focus"
    }
  },
  {
    id: "chart-screenshot",
    icon: <Icon path={mdiChartLine} size={4} />,
    template: {
      id: "chart-screenshot",
      commands: [
        {
          delay: 1000,
          id: uid(),
          payload: {
            chartType: EvaChart.RateCum,
            product: "Oil + Cond"
          } as SetChartPayload,
          topic: Topics.SetChartSettings
        },
        {
          delay: 500,
          id: uid(),
          payload: {} as ChartScreenshotPayload,
          topic: Topics.OpenChartScreenshot
        },
        {
          delay: 2000,
          id: uid(),
          payload: null,
          topic: Topics.TakeChartScreenshot
        }
      ],
      name: "Chart Screenshot"
    }
  },
  {
    id: "map-screenshot",
    icon: <Icon path={mdiChartLine} size={4} />,
    template: {
      id: "map-screenshot",
      commands: [
        {
          delay: 2000,
          id: uid(),
          payload: {
            scale: 1
          } as MapScreenshotPayload,
          topic: Topics.OpenMapScreenshot
        },
        {
          delay: 8000,
          id: uid(),
          payload: null,
          topic: Topics.TakeMapScreenshot
        }
      ],
      name: "Map Screenshot"
    }
  }
];
